import moment from "moment"

const intervals = [
    { label: "Automatic aggregation", value: 0 },
    { label: "5 minutes", value: 300 },
    { label: "15 minutes", value: 900 },
    { label: "30 minutes", value: 1800 },
    { label: "1 hour", value: 3600 },
    { label: "4 hour", value: 3600 * 4 },
    { label: "12 hour", value: 3600 * 12 },
    { label: "1 day", value: 3600 * 24 },
]

export default {
    namespaced: true,
    state() {
        return {
            pageTitle: null,
            range: [moment().startOf("day").unix(), moment().endOf("day").unix()],
            rangeMode: "day",
            interval: intervals[0],
            site: null,
            isCookieBannerVisible: false,
        }
    },
    getters: {
        getPageTitle(state) {
            return state.pageTitle
        },
        getRange(state) {
            return state.range
        },
        getRangeMode(state) {
            return state.rangeMode
        },
        getInterval(state) {
            return state.interval
        },
        getIntervalValue(state) {
            return state.interval.value
        },
        getIntervals() {
            return intervals
        },
        getSiteLogo(state) {
            return state.site.logo
        },
        getSiteInfo(state) {
            return state.site
        },
        isCookieBannerVisible(state) {
            return state.isCookieBannerVisible
        },
    },
    mutations: {
        setPageTitle(state, data) {
            state.pageTitle = data
        },
        setRange(state, data) {
            state.range = data
        },
        setRangeMode(state, mode) {
            state.rangeMode = mode
        },
        setInterval(state, data) {
            state.interval = data
        },
        setSiteInfo(state, info) {
            state.site = info
        },
        setSiteLogo(state, logo) {
            if (!state.site) {
                state.site = {}
            }
            state.site = { ...state.site, logo }
        },
        setIsCookieBannerVisible(state, value) {
            state.isCookieBannerVisible = value
        },
    },
    actions: {
        setIsCookieBannerVisible({ commit }, value) {
            commit("setIsCookieBannerVisible", value)
        },
        setSiteInfo({ commit }, info) {
            commit("setSiteInfo", info)
        },
    },
}
